import { createRouter, createWebHistory } from 'vue-router'
const routes = [
    { path: '/login', component: () => import('@/pages/Login') },
    {
        path: '/',
        component: () => import('@/components/Frame'),
        children: [
            { path: '/', component: () => import('@/pages/Index') },
            { path: '/customer/list', component: () => import('@/pages/cusmoter/List') },
            { path: '/customer/add', component: () => import('@/pages/cusmoter/Form') },
            { path: '/customer/detail', component: () => import('@/pages/cusmoter/Form') },
            { path: '/project/list', component: () => import('@/pages/project/List') },
            { path: '/project/route', component: () => import('@/pages/project/Route') },
            { path: '/project/add', component: () => import('@/pages/project/Form') },
            { path: '/project/detail', component: () => import('@/pages/project/Form') },
            { path: '/contract/list', component: () => import('@/pages/project/contract/List') },
            { path: '/contract/add', component: () => import('@/pages/project/contract/Form') },
            { path: '/contract/detail', component: () => import('@/pages/project/contract/Form') },
            { path: '/quotation/list', component: () => import('@/pages/project/quotation/List') },
            { path: '/quotation/add', component: () => import('@/pages/project/quotation/Form') },
            { path: '/quotation/detail', component: () => import('@/pages/project/quotation/Form') },
            { path: '/demand/list', component: () => import('@/pages/project/demand/List') },
            { path: '/demand/add', component: () => import('@/pages/project/demand/Form') },
            { path: '/demand/detail', component: () => import('@/pages/project/demand/Form') },
            { path: '/bug/list', component: () => import('@/pages/project/bug/List') },
            { path: '/bug/add', component: () => import('@/pages/project/bug/Form') },
            { path: '/bug/detail', component: () => import('@/pages/project/bug/Form') },
            { path: '/returned/list', component: () => import('@/pages/project/returned/List') },
            { path: '/returned/add', component: () => import('@/pages/project/returned/Form') },
            { path: '/returned/detail', component: () => import('@/pages/project/returned/Form') },
        ]
    }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
